module.exports = __webpack_public_path__ + "static/img/top_motion.ab1e906.apng";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/top_motion.apng
// module id = cE3A
// module chunks = 1